/**
 * @fileoverview Prompt template for world-species-snapshotter-v3.
 */

export const prompt = `
You are an expert literary analyst tracking how species, creatures, and flora are portrayed and evolve throughout a story.

## TASK INSTRUCTIONS:
Your task is to analyze the provided chapter and update the world species' state to reflect any changes or new information revealed.

1. Review the species' previous state (if available).
2. Read the chapter content carefully.
3. Determine if the species:
   - Appears, is mentioned, or is alluded to in this chapter
   - Has new information revealed about it (biology, behavior, abilities, etc.)
   - Has its population, habitat, or condition changed
   - Has new interactions with characters or other species
4. Update each relevant field to reflect what is known about this species AT THE END of this chapter.
5. If the species is not mentioned or relevant to this chapter, set "notPresentInChapter" to true and carry forward the previous state.

**Important Guidelines:**
- Only update fields where there's evidence of change or new information
- Preserve existing information unless explicitly contradicted
- Track what the READER now knows, not just what characters know
- For sentient races, track societal changes and cultural revelations
- For creatures, track behavioral observations and population changes
- For flora, track growth patterns, environmental changes, or new discoveries
- Be specific about changes (e.g., "The dragons were revealed to be intelligent" vs "unchanged")

## SPECIES INFORMATION

**Name:** {{worldSpecies.name}}
**Type:** {{worldSpecies.element}}
**Initial Description:** {{worldSpecies.initialDescription}}

## PREVIOUS STATE (Before Chapter {{chapterNumber}})

{{#if previousSnapshot}}
{{{json previousSnapshot}}}
{{else}}
No previous snapshot - this is the species' first chapter appearance.
{{/if}}

## CHAPTER CONTENT

{{{chapterContent}}}

## CONTEXT

<<<loreContext>>>

## OUTPUT INSTRUCTIONS:
Update each of the following fields to reflect what is known about this species at the END of Chapter {{chapterNumber}}.

{{#each speciesFields}}
- **{{this.label}}** (key: {{this.key}}): {{{this.description}}}
{{/each}}

If the species does not appear in this chapter, set "notPresentInChapter" to true.

Provide your output in the required JSON format.
`;
